import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import Cookies from "universal-cookie";
import NumberFormat from "react-number-format";

import Grid from "@mui/material/Grid";
import makeStyles from "@mui/styles/makeStyles";

import SecurePaySummary from "./SecurePaySummary";

const useStyles = makeStyles(() => ({
  label: {
    fontSize: 16,
    fontWeight: 500,
    textAlign: "center",
    color: "#1c355e",
  },
}));

let SessionTimer = ({
  setIsExpired,
  validateSecurePaymentData,
  setIsSuccess,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const cookies = new Cookies();
  const [loadingTime, setLoadingTime] = useState(true);
  const [timeLeft, setTimeLeft] = useState(() => {
    const savedTime = cookies.get("sessionTimeLeft");
    return savedTime ? Number(savedTime) : 600;
  });
  const intervalRef = useRef();

  useEffect(() => {
    if (timeLeft <= 0) {
      setIsExpired(true);
      cookies.remove("sessionTimeLeft");
      return;
    }

    const savedTime = cookies.get("sessionTimeLeft");
    if (savedTime) {
      setTimeLeft(Number(savedTime));
    }

    intervalRef.current = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 0) {
          clearInterval(intervalRef.current);
          setIsExpired(true);
          cookies.remove("sessionTimeLeft");
          return 0;
        }

        const newTime = prevTime - 1;
        cookies.set("sessionTimeLeft", newTime, { path: "/" });
        return newTime;
      });
    }, 1000);

    return () => {
      clearInterval(intervalRef.current);
    };
  }, [timeLeft]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
  };

  return (
    <Grid style={{ marginTop: 20 }}>
      <Grid item>
        <div style={{ textAlign: "center" }}>
          <span className={classes.label}>{t("securepay.sessionTimer")}</span>
          <span
            style={{
              color: timeLeft <= 120 ? "red" : "#1c355e",
              fontSize: 16,
              fontWeight: 500,
            }}
          >
            {formatTime(timeLeft)}
          </span>
        </div>
        <div className={classes.label}>
          <span className={classes.label}>{t("securepay.client")}</span>
          <span className={classes.label}>
            {validateSecurePaymentData.clientName}
          </span>
        </div>
        <div className={classes.label}>
          <span className={classes.label}>{t("securepay.amountDue")}</span>
          <span className={classes.label}>
            <NumberFormat
              value={validateSecurePaymentData.amountDue}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$ "}
              xs={1}
              decimalScale={2}
              fixedDecimalScale={true}
            />
          </span>
        </div>
      </Grid>
      <Grid item>
        <SecurePaySummary
          validateSecurePaymentData={validateSecurePaymentData}
          loadingTime={loadingTime}
          setLoadingTime={setLoadingTime}
          setIsSuccess={setIsSuccess}
        />
      </Grid>
    </Grid>
  );
};

SessionTimer.propTypes = {
  setIsExpired: PropTypes.func.isRequired,
  setIsSuccess: PropTypes.func.isRequired,
  validateSecurePaymentData: PropTypes.object,
};

export default SessionTimer;
